import React, { Component } from "react";



class Service extends Component{
    render(){
        let data = [
            {
                icon: 'zmdi zmdi-wifi-off',
                title: 'NAVEGAR SIN INTERNET',
                desc: 'Use el GPS incorporado de su dispositivo para ubicarse incluso cuando esté fuera de la red.'
            },

            {
                icon: 'zmdi zmdi-devices',
                title: 'COMPATIBILIDAD',
                desc: 'Mapptrix es de fácil acceso desde cualquier dispositivo móvil.'
            },

            {
                icon: 'zmdi zmdi-pin',
                title: 'FÁCIL LOCALIZACIÓN',
                desc: 'La localización por coordenadas en los mapas de Mapptrix, permite encontrar rápidamente el punto exacto que se quiere encontrar.'
            }
        ];
        let DataList = data.map((val, i) => {
            return(
                <div className="col-lg-4 service-column" key={i}>
                    <div className="single-service text-center">
                        <div className="service-icon">
                            <i className={`${val.icon}`}></i>
                        </div>
                        <h4 className="title">{val.title}</h4>
                        <p className="desc">{val.desc}</p>
                    </div>
                </div>
            )
        });

        return (
            <div>
                {/* Start Service Area */}
                <div className={`service-area ${this.props.horizontal}`}>
                    <div className="container">
                        <div className="row">
                            {DataList}
                        </div>
                    </div>
                </div>
                {/* End Service Area */}
            </div>
        )
    }
}

export default Service;

